import { http } from '../../../api'

const seo = {
  namespaced: true,
  state: {
    seoList: null,
    blog: null
  },
  actions: {

    getSeoList: ({ commit }, params) => {
      let url = '/seo'
      if (params) {
        const q = new URLSearchParams(params)
        url = url + '?' + q.toString()
      }
      return http.get(url).then(res => {
        commit('setSeoList', res.data.data)
        return res.data
      })
    },
    getSeo: ({ commit }, id) => {
      return http.get('/seo/' + id).then(res => {
        commit('setSeo', res.data.data)
        return res.data.data
      })
    },
    createSeo: ({ commit }, params) => {
      return http.post('/seo', params.data).then(res => {
        commit('setSeoList', res.data.data)
        return res.data.data
      })
    },
    updateSeo: ({ commit }, params) => {
      return http.post('/seo-update/' + params.id, params.data).then(res => {
      })
    },
    deleteItem: ({ commit }, id) => {
      return http.delete('/seo/' + id).then(res => {
        commit('deleteSeo', id)
      })
    }
  },
  mutations: {
    setSeoList (state, data) {
      state.seoList = data
    },
    deleteSeo (state, id) {
      state.seoList = state.seoList.filter(item => item.id !== id)
    }
  },
  getters: {
    seoList: state => state.seoList
  }
}

export default seo
